export default "__VITE_ASSET__uuoHZPq1__"